import React from "react";
import { SVG, IconProps } from "../SVG";
export const MasterCard = (props: IconProps) => (
    <SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 19" {...props}>
        <g fill="none" fillRule="evenodd" transform="translate(1 1)">
            <rect
                width={24.5}
                height={17.5}
                x={-0.25}
                y={-0.25}
                fill="#FFF"
                stroke="#E7E9EF"
                strokeWidth={0.5}
                rx={2}
            />
            <path
                fill="#FF5E00"
                d="M15.158 3.847c2.581 0 4.674 2.076 4.674 4.638s-2.093 4.64-4.674 4.64a4.676 4.676 0 0 1-3.033-1.11 4.668 4.668 0 0 1-3.03 1.11c-2.581 0-4.674-2.078-4.674-4.64s2.093-4.638 4.674-4.638c1.157 0 2.216.417 3.032 1.108a4.668 4.668 0 0 1 3.03-1.108Z"
            />
            <path
                fill="#ED0006"
                d="M9.095 3.847c1.157 0 2.216.417 3.032 1.108a4.615 4.615 0 0 0-.002 7.06 4.668 4.668 0 0 1-3.03 1.11c-2.581 0-4.674-2.078-4.674-4.64s2.093-4.638 4.674-4.638Z"
            />
            <path
                fill="#F9A000"
                d="M15.158 3.847c2.581 0 4.674 2.076 4.674 4.638s-2.093 4.64-4.674 4.64a4.676 4.676 0 0 1-3.032-1.11 4.614 4.614 0 0 0 0-7.06 4.676 4.676 0 0 1 3.032-1.108Z"
            />
        </g>
    </SVG>
);
MasterCard.displayName = "MasterCard";
